import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_card_text = _resolveComponent("b-card-text")!
  const _component_b_card = _resolveComponent("b-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("h3", { class: "mt-4" }, "Auth Info", -1)),
    _cache[1] || (_cache[1] = _createElementVNode("hr", null, null, -1)),
    _createVNode(_component_b_card, { title: "OIDC User" }, {
      default: _withCtx(() => [
        _createVNode(_component_b_card_text, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.oidcUser), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_b_card, { title: "OIDC Access Token" }, {
      default: _withCtx(() => [
        _createVNode(_component_b_card_text, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.oidcAccessToken), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_b_card, { title: "OIDC Access Token Exp" }, {
      default: _withCtx(() => [
        _createVNode(_component_b_card_text, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.oidcAccessTokenExp), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_b_card, { title: "OIDC Error" }, {
      default: _withCtx(() => [
        _createVNode(_component_b_card_text, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.oidcError), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}